import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import {
  defaultResponseSuccessInterceptor,
  publicResponseErrorInterceptor,
} from '@/api/interceptors'
import { getAuthApiUrl } from '@/helpers/helpers'

// Note: public endpoint - the reset email's link host is derived from the request host (see
// getAuthApiUrl), so it must not go through the shared authAPI instance
const publicAPI = axios.create()
publicAPI.interceptors.response.use(
  defaultResponseSuccessInterceptor,
  publicResponseErrorInterceptor,
)

export const sendPasswordReset = async (email: string) => {
  const response = await publicAPI.get(`${getAuthApiUrl()}/password/${encodeURIComponent(email)}`)
  return response.data
}

export const useSendPasswordReset = () => useMutation({ mutationFn: sendPasswordReset })
